import {i18n} from 'i18n';

export const VALIDATION_MESSAGES = {
  required: i18n.t('This field is required'),
  email: i18n.t('Invalid address format.'),
};
